import styled from "styled-components";

function ProductItem({id, name, label, amount, onChange, checked}){
    return(
        <Container onClick={() => onChange(name, id)}>
            <CheckBox type="checkbox" name={name} checked={checked} readOnly/>
            <ItemDataWrap>
                <Data>{label}</Data>
                <Data>{`${amount.toLocaleString()}원`}</Data>
            </ItemDataWrap>
        </Container>
    )
}

const Container = styled.div`
     padding: 8px 12px;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    gap: 10px;
    border-bottom: none;
    &:last-child{
        border-bottom: 1px solid #ccc;
    }
    cursor: pointer;
`

const CheckBox = styled.input`
    width: 16px;
    height: 16px;
`

const ItemDataWrap = styled.div`
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
`

const Data = styled.div`
    font-size: 16px;
    color: #222;
`

export default ProductItem;